export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/environments/environment.ts